import {i18n} from '../plugins/i18n';

const shopParams = JSON.parse(localStorage.getItem('shop'));

function incVueComp(componentName) {
  return require(
      `../templates/${shopParams.theme_name}/pages/${componentName}.vue`).default;
}

const NotFound = incVueComp('NotFound');
const Home = incVueComp('Home');
const Gallery = incVueComp('Gallery');
const Album = incVueComp('Album');
const Albums = incVueComp('Albums');
const AllAlbums = incVueComp('AllAlbums');
const Login = incVueComp('Login');
const Registration = incVueComp('Registration');
const ForgotPassword = incVueComp('ForgotPassword');
const ResetPassword = incVueComp('ResetPassword');
const UserActivation = incVueComp('UserActivation');
const Profile = incVueComp('account/Profile');
const Invoices = incVueComp('account/Invoices');
const PersonalAlbums = incVueComp('account/PersonalAlbums');
const Downloads = incVueComp('account/Downloads');
const Cart = incVueComp('Cart');
const Checkout = incVueComp('Checkout');
const Favorites = incVueComp('Favorites');
const PrivacyPolicy = incVueComp('PrivacyPolicy');
const TermsOfUse = incVueComp('TermsOfUse');
const Imprint = incVueComp('Imprint');
const Finish = incVueComp('Finish');
const MyPhotos = incVueComp('MyPhotos');
const Contact = incVueComp('Contact');
const Cropper = incVueComp('Cropper');

const children = [
  {path: '404', name: '404', component: NotFound},
  {path: '', name: 'home', component: Home},
  {path: 'cropper', name: 'cropper', component: Cropper},
  {path: 'login', name: 'login', component: Login},
  {path: 'registration', name: 'registration', component: Registration},
  {path: 'forgot-password', name: 'forgot-password', component: ForgotPassword},
  {
    path: 'reset-password/:email/:token',
    name: 'reset-password',
    component: ResetPassword,
  },
  {
    path: 'activate/:email/:activationToken',
    name: 'user-activation',
    component: UserActivation,
  },
  {
    path: 'account',
    redirect: `account/profile`,
    component: {
      render(c) {
        return c('router-view');
      },
    },
    children: [
      {path: 'profile', component: Profile},
      {path: 'invoices', component: Invoices},
      {path: 'personal_albums', component: PersonalAlbums},
      {path: 'downloads', component: Downloads},
    ],
  },
  {path: 'gallery', name: 'gallery', component: Gallery},
  {path: 'album', name: 'all-albums', component: AllAlbums},
  {path: 'album/:page', name: 'all-albums', component: AllAlbums},
  {path: 'album/category/:categoryId/:year', name: 'albums-archive', component: AllAlbums},
  {path: 'album/category/:categoryId/:year/:page', name: 'albums-archive', component: AllAlbums},
  {path: 'album/gallery/:hash/order/:photo', name: 'photo', component: Album},
  {path: 'album/gallery/:hash/order', name: 'order', component: Album},
  {path: 'album/gallery/:hash/tag/:tag', name: 'tag', component: Album},
  {path: 'album/gallery/:hash', name: 'album', component: Album},
  {
    path: 'album/download/:hash/:downloadToken',
    name: 'download-album',
    component: Album,
  },
  {path: 'cat/:id', name: 'albums', component: Albums},
  {path: 'cart', name: 'cart', component: Cart},
  {path: 'checkout*', name: 'checkout', component: Checkout},
  {path: 'selected/:albumId', name: 'album-favorites', component: Favorites},
  {path: 'selected', name: 'favorites', component: Favorites},
  {path: 'terms-of-use', component: TermsOfUse},
  {path: 'imprint', component: Imprint},
  {path: 'privacy-policy', component: PrivacyPolicy},
  {path: 'complete/order/:orderId', name: 'finish', component: Finish},
  {path: 'my-photos', name: 'my-photos', component: MyPhotos},
  {path: 'contact', name: 'contact', component: Contact},
  {path: '*', redirect: '404'},
];

let routes;

const pathName = window.location.pathname.split('/');

if (shopParams.multi_language && !+shopParams.multi_language && pathName && pathName[1] === i18n.locale) {
  const url = window.location.pathname
    .replace(`/${i18n.locale}/`, '/');

  window.location.href = url;
}

if (shopParams.multi_language && +shopParams.multi_language) {
  routes = [
    {
      path: '/',
      redirect: `/${i18n.locale}`,
    },
    {
      path: '/:lang',
      component: {
        render(c) {
          return c('router-view');
        },
      },
      children,
    },
  ];
} else {
  routes = [
    {
      path: '/',
      component: {
        render(c) {
          return c('router-view');
        },
      },
      children,
    },
  ];
}

export default routes;
